import classNames from 'classnames'
import { Image } from '@/atoms/Image'

interface Props {
  cloudinaryPath: string
  className?: string
}
export const BrandLogo = ({ cloudinaryPath, className }: Props) => {
  return (
    <div style={{ aspectRatio: 2 / 1 }} className={classNames('w-[221px] md:w-[387px] relative', className)}>
      <Image src={cloudinaryPath} alt="hero" fill className="object-fit" />
    </div>
  )
}
